export default {
  isLoggedIn: state => state.auth.isLoggedIn
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js